export const AccountStatus = {
  PENDING_APPROVAL: 1,
  APPROVED: 2,
  REJECTED: 3,
  BLOCKED: 4,
};
